import { render, staticRenderFns } from "./tariffs.vue?vue&type=template&id=58a758f4&"
import script from "./tariffs.vue?vue&type=script&lang=js&"
export * from "./tariffs.vue?vue&type=script&lang=js&"
import style0 from "./tariffs.less?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports